module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/spec-offer-with-label-0ed4821cb2a1e42831a4d71500d95263.png";